import { TOTAL } from '@/configuration/clientConf';

export default function estClientBloque(client) {
  if (!client) return false;
  return client.blocageLevel === TOTAL;
}



// WEBPACK FOOTER //
// ./src/services/client/estClientBloque.js